







































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import CrmHeader from "@/components/crmHeader/index.vue";
import {RouterModule} from "@/store/modules/router";
import {UserModule} from "@/store/modules/user";
import {
  getMyselfUser,
  getUserList,
  checkLogin,
} from "@/api/common";
import {wastchSokcet} from "@/utils/socket.io";
import {MessageModule} from "@/store/modules/message";

@Component({
  components: {CrmHeader},
})
export default class App extends Vue {
  isCheckLogin = false; // 当前是否通过登录验证
  isDisable = false; // 显示h5
  type = ''
  approvalType = ''
  flagType = ''
  sortIndex = []

  get userId() {
    return UserModule.userId || "";
  }

  get msgNoticeData() {
    return MessageModule.resData
  }

  get msgList() {
    const arr = MessageModule.msgList

    for (const key in arr) {
      if (arr[key].length > 0) {
        this.sortIndex.push(key)
      } else {
        const index = this.sortIndex.indexOf(key)
        if (index !== -1) {
          this.sortIndex.splice(index, 1)
        }
      }
    }
    this.sortIndex = this.newArrFn(this.sortIndex)
    return MessageModule.msgList
  }

  getOriginMsgList() {
    return MessageModule.msgList
  }

  created() {
    const url = window.location.href
    if (url.indexOf("isH5") >= 0) { //判断url地址中是否包含isH5字符串
      this.isDisable = true
    } else {
      this.getCheckLogin();
    }
  }


  newArrFn(arr) {
    const newArr = []
    for (let i = 0; i < arr.length; i++) {
      newArr.indexOf(arr[i]) === -1 ? newArr.push(arr[i]) : newArr
    }

    return newArr
  }

  async getCheckLogin() {
    await checkLogin();
    this.isCheckLogin = true;
    this.getUserInfo();
    this.initRouter();
    this.getUserList();
  }

  async getUserInfo() {
    const data: any = await getMyselfUser();
    UserModule.SET_USER_INFO(data);
  }

  async getUserList() {
    const data: any = await getUserList();
    UserModule.SET_USER_LIST(data);
  }

  closeMsg(name) {

    this.$store.commit('DELETE_MESG_ITEM', name)


  }

  // 查看
  viewMsg(types, approvalType) {
    if (types == 'messageReviewUser') {
      //  审批
      this.openPage('/message/approval?approvalType=' + approvalType);
    } else if (types == 'remind') {
      // 提醒
      this.openPage('/message/remind');
    } else if (types == 'Notice') {
      //  通知
      this.openPage('/message/notice');
    } else if (types == 'messageReviewCc') {
      //抄送
      this.openPage('/message/approval?approvalType=' + approvalType);
    }
    this.$store.commit('DELETE_MESG_ITEM', types)
  }

  openPage(url: string) {
    const win = window.open(window.location.origin + url, '_blank')

    const time = setInterval(() => {
      if (win.closed) {
        clearInterval(time)
      }
    }, 500)
  }


  initRouter() {
    RouterModule.initRouter1();
  }

  initSocket() {
    const time = setInterval(() => {
      if (Vue.prototype.$socket.on) {
        wastchSokcet(this.userId).then((res: any) => {

          const types = res.types
          if (types === 'remind') {
            this.type = '提醒'
          } else if (types === 'messageReviewUser') {
            this.type = '审批'
            this.approvalType = '0'
          } else if (types === 'messageReviewCc') {
            this.type = '抄送'
            this.approvalType = '2'
          }
          res.types = this.type
          this.$store.commit('GETMSGLIST', res)


        });

        clearInterval(time)
      }
    }, 100)
  }


}
